class WidgetService {

  checkPlacement(placements, currentPlacement) {
    let response = false;
    if (placements) {
      for (let i = 0; i < placements.length; i++) {
        if (placements[i].placement == currentPlacement) {
          if (placements[i].show == 1) {
            response = true;
          }
          return response;
        }
      }
    }
    return response;
  }

  getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    return variantId;
  }
}

export default WidgetService;